import { toast } from 'react-toastify';

import { Spinner, useModalController } from '@uikit';

import { useReferralUrlQuery } from '@query';

import Share2 from '@uikit/icons/Share2';

import { useAuth } from '@shared/common/providers/AuthProvider';
import { useAuthModal } from '@shared/common/providers/GlobalModalsProvider';
import { getErrorMessage } from '@shared/helpers/error';
import { SocialName } from '@shared/helpers/sharing';

import ShareModal from '@store:web/components/common/ShareModal/ShareModal';

const socialsTexts: Record<SocialName, string> = {
  email:
    "Look what I've found on the Magic Store!🤩 This app is a gem 💎 Check it out here: {{url}}",
  reddit:
    "Look what I've found on the Magic Store!🤩 This app is a gem 💎 Check it out here: {{url}}",
  twitter:
    "Look what I've found on the #MagicStore, the World’s #Web3 App Store!🤩 Check the #dApp out here: {{url}}",
  telegram:
    "Look what I've found on the Magic Store!🤩 This app is a gem 💎 Check it out here: {{url}}",
  whatsapp:
    "Look what I've found on the Magic Store!🤩 This app is a gem 💎 Check it out here: {{url}}",
  facebook:
    "Look what I've found on the Magic Store!🤩 This app is a gem 💎 Check it out here: {{url}}",
  linkedin:
    "Look what I've found on the Magic Store!🤩 This app is a gem 💎 Check it out here: {{url}}",
};

// TODO: create component based on useReferralUrlQuery hook to share any url
const AppDetailsSharing = ({ id }: { id: string }) => {
  const { isAuth } = useAuth();
  const authModal = useAuthModal();
  const shareModal = useModalController();
  const {
    data: urlForShare,
    refetch: refetchUrlForShare,
    isLoading: isUrlForShareLoading,
  } = useReferralUrlQuery(id, 'app', {
    enabled: false,
  });

  const handleShareButtonClick = async () => {
    if (!isAuth) {
      authModal.open();

      return;
    }

    if (!urlForShare) {
      try {
        await refetchUrlForShare();
      } catch (error) {
        toast.error(getErrorMessage(error, 'Something went wrong'));
      }
    }

    shareModal.open();
  };

  return (
    <>
      <button
        onClick={handleShareButtonClick}
        className="icon-button button-ghost button-lg button-color-secondary"
        disabled={isUrlForShareLoading}
        data-qa="info-share"
        aria-label="Share"
      >
        {isUrlForShareLoading ? (
          <Spinner size="sm" className="w-5 h-5" />
        ) : (
          <Share2 className="icon-sm" />
        )}
      </button>

      <ShareModal
        {...shareModal.props}
        heading="Share app with friends"
        url={urlForShare?.sharingLink || ''}
        text={socialsTexts}
      />
    </>
  );
};

export default AppDetailsSharing;
